<template>
    <ui-card
        icon="fal fa-id-card"
        title="Perfis Dinâmicos"
        text="Crie, edite e remova os perfis dinâmicos dos usuários."
    >
        <template #body>
            <ui-load-success
                v-if="loader.overlay"
                :loading="loader.overlayLoading"
                :success="loader.overlaySucess"
            />

            <dynamics-user-modal :modal-name="getModalName" />

            <ui-modal-message
                :name="getModalDeleteName"
                :finally-action="dynamicUsersHandler"
                service="user"
                title="Deseja realmente excluir a(s) Tag(s)?"
                text="Cuidado, esta ação não poderá ser desfeita."
                btn-type="danger"
                btn-text="Confirmar"
                icon="fal fa-trash-alt"
                color-circle="danger"
                icon-circle
            />

            <div class="area-card">
                <transition name="fade">
                    <div v-show="loader.body" class="loading-card">
                        <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                    </div>
                </transition>

                <div class="dynamic-users">
                    <ui-util-box-text-slot
                        v-for="(user, index) in form.dynamicUsers"
                        :key="`${user.id}-${index}`"
                        :title="user.name"
                        design="no-bb"
                    >
                        <ui-menu-card>
                            <button
                                v-for="(menu, index) in menuOptions"
                                :key="`${index}-${menu.label}`"
                                type="button"
                                @click="handleAction(menu.action, user)"
                            >
                                {{ menu.label }}
                            </button>
                        </ui-menu-card>
                    </ui-util-box-text-slot>
                </div>
            </div>
        </template>
        <template #fl/>
        <template #fr>
            <ui-util-input-button :is-input-valid="form.inputNewUser.length >= 20" design="no-bt">
                <template #input>
                    <ui-input
                        v-model="form.inputNewUser"
                        placeholder="Digite o nome do Perfil."
                        design="br-off"
                        container-design="mb-0"
                        type="text"
                        size="lg"
                        groupicon="fal fa-user-alt"
                        invertgroup
                        maxlength="20"
                    />
                </template>
                <template #buttons>
                    <ui-button
                        :disabled="!canSubmit"
                        design="lg primary brl-off"
                        @click="createDynamicUser"
                    >Adicionar Perfil</ui-button
                    >
                </template>
                <template #msg >
                    <span >Este campo deve ter, no máximo, 20 caracteres.</span>
                </template>
            </ui-util-input-button>
        </template>
    </ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'
	import { uiUtilInputButton, uiUtilBoxTextSlot } from '@/components/ui/form/util'

	import { uiLoadIndicator, uiMenuCard } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import DynamicsUserModal from './components/dynamics-user-modal/index.vue'
	import { uiModalMessage } from '@/components/ui/modal'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'

	import { user } from '@/services/axios'

	const defaultForm = () => ({
		dynamicUsers: null,
		inputNewUser: '',
	})

	const defaultDisabled = () => ({})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	const modalName = 'dynamics-user-modal'

	const defaultMenuOptions = () => [
		{
			active: true,
			label: 'Editar Perfil',
			action: `modal-open-${modalName}`,
		},
		{
			active: true,
			label: 'Excluir Perfil',
			action: 'dynamic-user-list:delete',
		},
	]

	export default {
		name: 'configuration-users-dynamics',

		components: {
			uiCard,
			uiButton,
			uiMenuCard,
			uiInput,
			uiLoadSuccess,
			uiLoadIndicator,
			uiUtilBoxTextSlot,
			uiUtilInputButton,
			uiModalMessage,
			DynamicsUserModal,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				loader: { ...defaultLoader() },
				menuOptions: [...defaultMenuOptions()],
			}
		},

		computed: {
			canSubmit() {
				return !this.loader.body && !!this.form.inputNewUser
			},

			getModalName() {
				return modalName
			},

			getModalDeleteName() {
				return this.getTableName + '--delete'
			},
		},

		async created() {
			this.$root.$on('dynamic-user-list:delete', async (userDynamic) => {
				const config = {
					method: 'delete',
					url: `groups/dynamics/`,
					id: userDynamic.id,
					formdata: {},
				}
				this.$root.$emit('modal-msg-open-' + this.getModalDeleteName, config)
			})

			this.$root.$on('dynamic-user-list:update', async () => {
				await this.dynamicUsersHandler()
			})

			await this.dynamicUsersHandler()
		},

		methods: {
			handleAction(action, data) {
				this.$root.$emit(action, data)
			},

			editDynamicUser() {
				this.$root.$emit(`modal-open-${this.getModalName}`, this.data)
			},

			async createDynamicUser() {
				const data = { name: `${this.form.inputNewUser}`, permissions: ['login'] }
				this.form.inputNewUser = ''
				try {
					await user.createDynamicUser(data)
					this.dynamicUsersHandler()
				} catch (error) {
					this.$mx_alertThisOnError(error)
				}
			},

			async dynamicUsersHandler() {
				try {
					this.loader.body = true
					this.form.dynamicUsers = (await user.readDynamics()).data
					this.loader.body = false
				} catch (error) {
					this.$mx_alertThisOnError(error)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
